import { stringify } from 'query-string';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import { MAX_LIMIT } from 'config';
import getRegionBreakdown from 'helpers/getRegionBreakdown';
import getCountryIds from 'helpers/getCountryIds';

type Period = 'day' | 'week' | 'month' | 'year';

export default getShortFormVideoTrend;
export { getShortFormVideoTrend };
export interface IShortFormVideoTrendUrlProps {
  countryIds?: any;
  entityIds: string[];
  limit?: number;
  metricType: 'views' | 'creations';
  sfvEntityType: 'track' | 'artist';
  period?: Period;
  region?: string;
  platform?: number;
  contentType?: string;
  compareMode?: string;
  customRegion?: string | string[];
  customDate?: { fromDate: number; toDate: number } | null;
  download?: boolean;
  breakdown?: number[];
}

function getShortFormVideoTrend(args: IShortFormVideoTrendUrlProps): string {
  const {
    countryIds,
    entityIds,
    limit = MAX_LIMIT,
    metricType,
    sfvEntityType,
    period,
    region,
    platform,
    contentType,
    compareMode,
    customRegion,
    customDate,
    download,
    breakdown,
  } = args;

  const apiEntityType = entityTypeToApiType(sfvEntityType);

  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    limit,
    customerFilter: platform,
    metricType,
    period,
    regionBreakdown: getRegionBreakdown(
      countryIds,
      region,
      compareMode,
      customRegion
    ),
    contentType,
    download,
    dateFrom: customDate?.fromDate,
    dateTo: customDate?.toDate,
    breakdown,
  });

  return `/api/shortFormVideo/trend/${apiEntityType}/${entityIds}${
    params !== '' ? `?${params}` : ''
  }`;
}
